/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Pronunciation_TitleInputs */

const en_why_listening_pronunciation_title = /** @type {(inputs: Why_Listening_Pronunciation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Says the jargon right`)
};

const es_why_listening_pronunciation_title = /** @type {(inputs: Why_Listening_Pronunciation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronuncia bien la jerga`)
};

/**
* | output |
* | --- |
* | "Says the jargon right" |
*
* @param {Why_Listening_Pronunciation_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_pronunciation_title = /** @type {((inputs?: Why_Listening_Pronunciation_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Pronunciation_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_pronunciation_title(inputs)
	return en_why_listening_pronunciation_title(inputs)
});